type Option = {
  value: string;
  label: string;
};

export const locations: Option[] = [
  { value: 'new-york', label: 'New York' },
  { value: 'los-angeles', label: 'Los Angeles' },
  { value: 'chicago', label: 'Chicago' },
];

export const gender: Option[] = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
];

export const languages: Option[] = [
  { value: 'english', label: 'English' },
  { value: 'spanish', label: 'Spanish' },
  { value: 'french', label: 'French' },
];

export const prefixes: Option[] = [
  { value: 'dr', label: 'Dr.' },
  { value: 'prof', label: 'Prof.' },
];

export const specialties: Option[] = [
  { value: 'cardiology', label: 'Cardiology' },
  { value: 'neurology', label: 'Neurology' },
  { value: 'pediatrics', label: 'Pediatrics' },
];

export const qualifications: Option[] = [
  { value: 'mbbs', label: 'MBBS' },
  { value: 'md', label: 'MD' },
  { value: 'phd', label: 'PhD' },
];
